import qs from 'qs';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { SHIP_TO_ID_PARAM } from '../../constants/routes';
import { getUserID } from '../../libs/auth/index';
import PageNotFound from '../page-not-found';
import { SoldToPage } from './page';

export const SOLD_TO_PAGE_ROUTE = '/sold-to';

export const soldToRoute = (soldToId: string, params?: SoldToPageParams) => {
  const queryString = qs.stringify(params, { addQueryPrefix: true });
  const uid = getUserID();
  if (queryString) {
    return `${SOLD_TO_PAGE_ROUTE}/${soldToId}${queryString}&uid=${uid}`;
  }
  return `${SOLD_TO_PAGE_ROUTE}/${soldToId}${queryString}?uid=${uid}`;
};

export interface ISoldToPageParams {
  [SHIP_TO_ID_PARAM]?: string;
}

export type SoldToPageParams = ISoldToPageParams;

const parseQueryString = (search: string): SoldToPageParams => {
  return qs.parse(search, {
    ignoreQueryPrefix: true,
  });
};

export default function SoldToRoute() {
  const { soldToId } = useParams();
  const { search } = useLocation();
  const params = parseQueryString(search);
  const { shipToId } = params;

  if (soldToId) {
    return <SoldToPage soldToId={soldToId} shipToId={shipToId} />;
  }
  return <PageNotFound />;
}
